import providerColumnProps from './ProviderColumnProps';
import siteColumnProps from './SiteColumnProps';
import providerFields, { providerDefaultValues } from './ProviderFields';
import siteFields from './SiteFields';
import { FieldTextMap } from '../../Utils/types';

export const userManagementColumnProps: Record<string, any[]> = {
  providers: providerColumnProps,
  sites: siteColumnProps,
};

export const userManagementFormFields = {
  providers: providerFields,
  sites: siteFields,
};

export const fieldDefaultValues = {
  providers: providerDefaultValues,
  sites: {},
};

export const fieldText: FieldTextMap = {
  providers: {
    update: 'buttons.updateUserInfo',
    deactivate: 'buttons.deactivateUser',
  },
  sites: {},
};

export const entityConfig: Record<string, { isRowClickable: boolean }> = {
  providers: { isRowClickable: true },
  sites: { isRowClickable: false },
};
